var system = ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', '"Noto Sans"', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"', '"Noto Color Emoji"'];
var heading = ['"Open Sans"'].concat(system);
var body = ['"Source Sans Pro"'].concat(system); // const monospace = [
//   'SFMono-Regular',
//   'Menlo',
//   'Monaco',
//   'Consolas',
//   '"Liberation Mono"',
//   '"Courier New"',
//   'monospace',
// ];

export default {
  heading: heading.join(','),
  body: body.join(',')
};